module.exports = __webpack_public_path__ + "static/media/feature.f41d9c3d.png";